/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Request schema for closing a Nori conversation at the conclusion of a Curai visit
 */
export interface CloseClinicRequestRequest {
  /** The ID of the clinic request */
  clinic_request_id: string;
  /** Nori user ID of the conversation's patient */
  user_id: string;
  /** Whether the request was cancelled */
  cancelled?: boolean;
}
